module.exports = __webpack_public_path__ + "img/prod-list-arrow.cd0d0e9e.svg";